import { defineMessages } from 'react-intl';

export default defineMessages({
  AdministrativeAreaCountyLabel: {
    id: 'Address.Labels.County',
    defaultMessage: 'County',
  },
  AdministrativeAreaDepartmentLabel: {
    id: 'Address.Labels.Department',
    defaultMessage: 'Department',
  },
  AdministrativeAreaDistrictLabel: {
    id: 'Address.Labels.District',
    defaultMessage: 'District',
  },
  AdministrativeAreaPrefectureLabel: {
    id: 'Address.Labels.Province',
    defaultMessage: 'Province',
  },
  AdministrativeAreaProvinceLabel: {
    id: 'Address.Labels.Province',
    defaultMessage: 'Province',
  },
  AdministrativeAreaStateLabel: {
    id: 'Address.Labels.State',
    defaultMessage: 'State',
  },
  AdministrativeAreaRegionLabel: {
    id: 'Address.Labels.Region',
    defaultMessage: 'Region',
  },
  AddressLineLabel: {
    id: 'Address.Labels.AddressLine',
    defaultMessage: 'Address',
  },
  AddressLine1Label: {
    id: 'Address.Labels.AddressLine1',
    defaultMessage: 'Address Line 1',
  },
  AddressLine2Label: {
    id: 'Address.Labels.AddressLine2',
    defaultMessage: 'Address Line 2',
  },
  CityLabel: {
    id: 'Address.Labels.City',
    defaultMessage: 'City',
  },
  CountryLabel: {
    id: 'Address.Labels.Country',
    defaultMessage: 'Country',
  },
  EmptySelectOption: {
    id: 'Address.EmptySelectOption',
    defaultMessage: '-- Select --',
  },
  PostalCodeLabel: {
    id: 'Address.Labels.PostalCode',
    defaultMessage: 'Postal Code',
  },
  RequiredFieldMessage: {
    id: 'Address.ErrorMessages.RequiredFieldMessage',
    defaultMessage: 'This field is required',
  },
  InvalidPostalCodeMessage: {
    id: 'Address.ErrorMessages.InvalidPostalCode',
    defaultMessage: 'Invalid zip code',
  },
});
